/* eslint-disable no-unused-vars */
import { useState, useEffect, useCallback, useMemo } from 'react';
import { cloneDeep } from 'lodash-es';
import { useDispatch, useSelector } from 'react-redux';
import { formErrorsCampaign_action } from 'store/actions';

const linkConvert = {
  tracking: 'Tracking_Link',
  vta: 'VTA_Link',
  deeplink: 'Deep_Link',
  impression: 'Impression_Link',
};

const convertLink = (link) => {
  if (link === null || link === undefined) return '';
  return link;
};

export const useFacade = (Deep_Link, Impression_Link, Tracking_Link, VTA_Link) => {
  const dispatch = useDispatch();
  const state_model = useSelector(
    (state) => state?.creatives?.creativeAndTrackingData?.link_state_model_dic,
  );

  let trackingError = useSelector((state) => state?.tracking?.trackingError);
  const creativesTrackingError = useSelector(
    (state) => state?.formErrorsCampaign.creativesConversionTracking,
  );

  const commonErrorInTrackingSection = useSelector(
    (state) => state?.formErrorsCampaign?.conversionTracking,
  );

  const dataObject = useMemo(() => {
    const res = {
      Deep_Link: convertLink(Deep_Link),
      Impression_Link: convertLink(Impression_Link),
      Tracking_Link: convertLink(Tracking_Link),
      VTA_Link: convertLink(VTA_Link),
    };
    const fieldsToShow = Object.keys(state_model).map((name) => linkConvert[name]);
    for (const fieldName in res) {
      if (!fieldsToShow.includes(fieldName)) {
        delete res[fieldName];
      }
    }
    return res;
  }, [Deep_Link, Impression_Link, Tracking_Link, VTA_Link, state_model]);

  const convertObj = useMemo(() => {
    const cloneData = cloneDeep(dataObject);
    const res = Object.entries(cloneData).filter((item) => item[1] !== null);
    return res;
  }, [Deep_Link, Impression_Link, Tracking_Link, VTA_Link, dataObject]);

  const currentLink = useCallback((data, fields) => {
    const res = data.find((item) => {
      return fields.includes(item[0]) ?? '';
    });
    return res;
  }, []);

  const dataTrakingDeepUrl = useMemo(() => {
    return currentLink(convertObj, ['Tracking_Link', 'Deep_Link']);
  }, [convertObj]);

  const dataImpressionVTAUrl = useMemo(() => {
    return currentLink(convertObj, ['Impression_Link', 'VTA_Link']);
  }, [convertObj]);

  const commonTrackingError = useMemo(() => {
    return (
      trackingError[dataTrakingDeepUrl?.[0]] ||
      trackingError[dataImpressionVTAUrl?.[0]] ||
      creativesTrackingError
    );
  }, [trackingError, dataTrakingDeepUrl, dataImpressionVTAUrl, creativesTrackingError]);

  useEffect(() => {
    if (commonTrackingError !== commonErrorInTrackingSection) {
      dispatch(
        formErrorsCampaign_action.updateErrorField({
          errorField: 'conversionTracking',
          newValue: commonTrackingError,
        }),
      );
    }
  }, [trackingError, commonErrorInTrackingSection, commonTrackingError, creativesTrackingError]);

  const clearTrackingError = useCallback(() => {
    if (creativesTrackingError) {
      dispatch(
        formErrorsCampaign_action.updateErrorField({
          errorField: 'creativesConversionTracking',
          newValue: false,
        }),
      );
    }
  }, [creativesTrackingError]);

  return {
    dataTrakingDeepUrl,
    dataImpressionVTAUrl,
    clearTrackingError,
  };
};
